$(function() {
    var $elements = $('.defer-load');
    var loaded = {};
    
    window.loadResources = function () {
        for (var i = 0; i < $elements.length; i++) {
            var position = $elements[i].getBoundingClientRect();
            var func = $($elements[i]).attr('data-action');
            if (
                !loaded.hasOwnProperty(func)
                && position.top !== 0
                && position.top - $(window).height() < 0
            ) {
                var params = $($elements[i]).attr('data-params');
                params = params !== undefined ? params.split(',') : [];
                window[func](params);
                loaded[func] = true;
            }
        }

    };
    
    window.googleMap = function (params) {
        if (params[0]) {
            const key = params[0];
            const lang = params[1];
            const el = document.createElement("script");
            el.type = "text/javascript";
            el.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=initGoogleMap&language=${lang}`;
            el.async = true;
            el.defer = true;
            document.getElementsByTagName('head')[0].appendChild(el);
        }
    };

    window.map = function () {
        var el = document.createElement("script");
        el.type = "text/javascript";
        el.src = "//api-maps.yandex.ru/2.1/?lang=ru_RU&onload=init&load=Map,control.ZoomControl,GeoObjectCollection,map.GeoObjects,templateLayoutFactory,Placemark,map.addon.balloon,geoObject.addon.balloon,geocode";
        el.async = true;
        document.getElementsByTagName('head')[0].appendChild(el);
    };

    window.share = function() {
        var el = document.createElement("script");
        el.type = "text/javascript";
        el.src = "//yastatic.net/share2/share.js";
        el.async = true;
        document.getElementsByTagName('head')[0].appendChild(el);
    };
    
    loadResources();

    $(document).on('scroll', function(){
        loadResources();
    });
    
    $(window).resize(function(){
        loadResources();
    });
});